class MathCalculationService {
    round(value: number, precision: number): number {
        const helperValue = Math.pow(10, precision);
        return Math.round((value + Number.EPSILON) * helperValue) / helperValue;
    }
}

export const mathCalculationService = new MathCalculationService();